var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"reset"},on:{"click":function($event){return _vm.onClick()}}},[_c('img',{attrs:{"src":_vm.movieImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }